import { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { 
  Info, 
  AlertTriangle
} from 'lucide-react';
import { UnifiedPlanUsage } from './UnifiedPlanUsage';
import type { CompanyBillingData, CompanySubscriptionTier } from '@/types/billing';

interface SubscriptionLayoutProps {
  companyData: CompanyBillingData;
  subscriptionTiers: CompanySubscriptionTier[];
  onChangePlans: (companyData: CompanyBillingData) => void;
  onRefetchBilling?: () => Promise<void>;
  isActive?: boolean;
}

export function SubscriptionLayout({ 
  companyData, 
  subscriptionTiers,
  onChangePlans,
  onRefetchBilling,
  isActive = true
}: SubscriptionLayoutProps) {
  // Check if there are pending changes (mock for now)
  const hasPendingChanges = false;

  return (
    <div className="space-y-6">

      {/* Pending Changes Alert */}
      {hasPendingChanges && (
        <Alert className="border-orange-200 bg-orange-50">
          <Info className="h-4 w-4 text-orange-600" />
          <AlertDescription className="flex items-center justify-between">
            <div className="text-orange-800">
              <strong>Pending changes scheduled for Sep 9, 2025</strong>
              <br />
              Pro → Lite
            </div>
            <Button variant="outline" size="sm" className="text-orange-700 border-orange-300">
              Cancel changes
            </Button>
          </AlertDescription>
        </Alert>
      )}

      {/* Unified Plan and Usage Display */}
      <UnifiedPlanUsage 
        companyData={companyData}
        subscriptionTiers={subscriptionTiers}
        onChangePlans={onChangePlans}
        onRefetchBilling={onRefetchBilling}
        isActive={isActive}
      />

    </div>
  );
}